export const tuesdayUppercase = "Bqa";
export default {tuesdayUppercase};